import { Dropdown } from 'primereact/dropdown'
import { classNames } from "primereact/utils"
import InputFrame from "./InputFrame"
import { useRef, useState } from 'react'

export default function InputDropdown2Form(props) {

    const field = props.controller.field
    const fieldState = props.controller.fieldState
    const opened = useRef(false)
    const [iconRefresh, setIconRefresh] = useState('pi-refresh')
    const [overlayVisible, setOverlayVisible] = useState(false)

    const fieldOnBlur = field.onBlur
    const fieldValue = field.value
    const restField = { ...field }
    delete restField.onBlur
    delete restField.value

    const onLoad = (e) => {

        if (opened.current) {
            return
        }

        opened.current = true
        props.onLoad && props.onLoad(e)

    }

    return (
        <>
            <InputFrame {...props}>
                {opened.current && !props.disabled && !props.hideRefresh && <i className={`pi ${iconRefresh} text-xs ml-2`} onClick={e => {

                    if (!iconRefresh.includes('spin') && !iconRefresh.includes('check')) {

                        setIconRefresh('pi-spin pi-refresh')
                        e.preventDefault()
                        props.onLoad && props.onLoad({})
                        setIconRefresh('pi-check')
                        setTimeout(_ => setIconRefresh('pi-refresh'), 5000)
                    }
                }} ></i>}
                <Dropdown
                    {...restField}
                    id={'box-' + field.name}
                    inputId={field.name}
                    locale="pt"
                    autoComplete="off"
                    className={'p-inputtext-sm ' + (fieldState.isDirty ? '' : '') + classNames({ 'p-invalid': fieldState.error })}
                    size='small'
                    options={props.options || []}
                    value={props.options?.find(opt => opt[props.optionKey] === fieldValue) ?? null}
                    onClick={(e) => {
                        props.onClick && props.onClick(e)
                        onLoad(e)
                    }}
                    onShow={(e) => {
                        props.onShow && props.onShow(e)
                        setOverlayVisible(true)
                        onLoad(e)
                    }}
                    onHide={(e) => {
                        setOverlayVisible(false)
                        props.onHide && props.onHide(e)
                        fieldOnBlur && fieldOnBlur()
                    }}
                    onChange={(e) => {
                        const newValue = e.value?.[props.optionKey] ?? null
                        field.onChange(newValue)
                        props.onChange && props.onChange(e)
                    }}
                    onBlur={(e) => {
                        if (!overlayVisible) {
                            fieldOnBlur && fieldOnBlur(e)
                            props.onBlur && props.onBlur(e)
                        }
                    }}
                    optionLabel={props.optionLabel || ''}
                    placeholder={props.placeholder || ''}
                    emptyMessage={props.emptyMessage || 'Selecionar'}
                    disabled={props.disabled}
                    showClear={false}
                    autoOptionFocus={true}

                />
            </InputFrame>
        </>
    )
}
